import React, { createContext, useContext, useEffect, useState } from 'react'
import { getEmployeeByToken } from '../api/api'

const AuthContext = createContext()

const AuthProvider = ({children}) => {
  const [isLogin,setLogin] = useState(false)
  const [user,setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(()=>{
    getEmployeeByToken().then((res)=>{
      setUser(res.data)
      setLogin(true)
    }).catch((err)=>{
      console.log(err.message)
      setUser(null)
      setLogin(false)
    }).finally(()=>{
      setLoading(false)
    })
  },[])

  return ( 
    <AuthContext.Provider value={{isLogin,setLogin,user,setUser,loading}}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = ()=>{
  return useContext(AuthContext)
}

export default AuthProvider